import { parseOptionalLuxonDateTimeFromIsoString } from './parse-optional-luxon-datetime-from-iso-string.function';

/**
 * Parses an unknown value into a JavaScript Date when it is a string that
 * parseOptionalLuxonDateTimeFromIsoString accepts. For untyped remote payloads
 * such as webhook bodies.
 *
 * @param value - Value to parse, often a property read from a record
 * @returns A Date in the instant represented by the string, or null
 */
export function parseOptionalDateFromUnknown(value: unknown): Date | null {
	if (typeof value !== 'string') {
		return null;
	}

	const dateTime = parseOptionalLuxonDateTimeFromIsoString(value);

	return dateTime?.toJSDate() ?? null;
}
